/* eslint-disable no-debugger */
export default {
  init() {
  },
  finalize() {
  },
}




// WEBPACK FOOTER //
// ./scripts/routes/pricing.js